import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId, isLastItem } from '@airtel/air-design-system';
import { Fragment } from 'react';
import { ScrollView, View } from 'react-native';
import { getUpsellNudgetWidgetStyles, getHeaderStyle, getCellStyle, getColumnSeparatorStyle } from './UpsellNudgetWidgetStyles';
import { UpsellCell } from './components/upsell-cell';
import { UpsellTitle } from './components/upsell-title/UpsellTitle';
export var UpsellNudgetWidgetComponent = props => {
  var _props$header = props.header,
    header = _props$header === void 0 ? [] : _props$header,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    style = props.style,
    testID = props.testID,
    highlightMiddleColumn = props.highlightMiddleColumn,
    onUserAction = props.onUserAction;
  var upsellNudgetWidgetStyles = getUpsellNudgetWidgetStyles();
  return _jsx(_Fragment, {
    children: (header === null || header === void 0 ? void 0 : header.length) > 0 || (list === null || list === void 0 ? void 0 : list.length) > 0 ? _jsxs(View, Object.assign({
      style: [upsellNudgetWidgetStyles.container, style]
    }, getTestId(testID), {
      children: [(header === null || header === void 0 ? void 0 : header.length) > 0 && _jsx(View, Object.assign({
        style: upsellNudgetWidgetStyles.upsellHeaderContainer
      }, {
        children: header === null || header === void 0 ? void 0 : header.map((headerItem, headerIndex) => {
          return _jsxs(Fragment, {
            children: [_jsx(UpsellTitle, Object.assign({}, getTestId(testID + '_header', headerIndex.toString()), headerItem, {
              style: getHeaderStyle(highlightMiddleColumn, headerIndex)
            })), _jsx(View, {
              style: getColumnSeparatorStyle(highlightMiddleColumn, isLastItem(header, headerIndex))
            })]
          }, "upsell_header_" + headerIndex);
        })
      })), (list === null || list === void 0 ? void 0 : list.length) > 0 && _jsx(ScrollView, Object.assign({
        style: upsellNudgetWidgetStyles.tableScrollContainer,
        keyboardShouldPersistTaps: "handled"
      }, getTestId(testID, 'tableScrollContainer'), {
        children: list === null || list === void 0 ? void 0 : list.map((item, cellIndex) => {
          return _jsx(View, Object.assign({
            style: upsellNudgetWidgetStyles.upsellCellContainer
          }, {
            children: (item === null || item === void 0 ? void 0 : item.length) > 0 && (item === null || item === void 0 ? void 0 : item.map((cell, itemIndex) => {
              return _jsxs(Fragment, {
                children: [_jsx(UpsellCell, Object.assign({}, getTestId(testID + '_listItemUpsellCell', itemIndex.toString()), cell, {
                  style: getCellStyle(highlightMiddleColumn, itemIndex, cellIndex + 1 === (list === null || list === void 0 ? void 0 : list.length)),
                  onUserAction: onUserAction
                })), _jsx(View, {
                  style: getColumnSeparatorStyle(highlightMiddleColumn, isLastItem(item, itemIndex))
                })]
              }, "table_cell_" + cellIndex + "_" + itemIndex);
            }))
          }), "upsell_cell_" + cellIndex);
        })
      }))]
    })) : null
  });
};
UpsellNudgetWidgetComponent.genericRendererKey = 'AirUpsellNudgetWidget';